exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Navigation__container___vtAMv {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: -12px -12px 16px 0;\n  width: 100%;\n}\n\n.Navigation__item___pavVT {\n  background: rgba(34, 34, 34, .25);\n  color: white;\n  display: inline-block;\n  margin: 0 12px 12px 0;\n  padding: 8px 12px;\n  text-decoration: none;\n  -webkit-transition: background .08s;\n  transition: background .08s;\n  white-space: nowrap;\n}\n\n.Navigation__item___pavVT:hover,\n.Navigation__activeItem___2w26G {\n  background: rgba(34, 34, 34, .55);\n}\n", ""]);

// exports
exports.locals = {
	"container": "Navigation__container___vtAMv",
	"item": "Navigation__item___pavVT",
	"activeItem": "Navigation__activeItem___2w26G"
};